import type React from 'react';

import { useGetHandler } from '@vlabs/api/artemy/client';
import { EditIcon } from '@vlabs/icons';
import { PageHeader, usePageContext } from '@vlabs/monokit/shared/ui/page';
import { useHasPermission } from '@vlabs/permissions';
import { Breadcrumb, Breadcrumbs, Control } from '@vlabs/uikit';
import { generatePath, Link } from 'react-router-dom';

import { useHandlerViewPageTranslation } from './i18n';
import { routes } from '../../../app/routes';

interface HandlerViewPageHeaderProps {
  handlerId: string;
}

function HandlerViewPageHeader({
  handlerId,
}: HandlerViewPageHeaderProps): React.JSX.Element {
  const { t } = useHandlerViewPageTranslation();
  const pageCtx = usePageContext();
  const canUpdate = useHasPermission('handler', 'update');
  const { data: handler } = useGetHandler(handlerId);
  const title = handler?.description ?? handlerId;

  return (
    <PageHeader
      actions={canUpdate ? (
        <Control.LinkButton
          as={Link as unknown as React.ReactElement}
          icon={<EditIcon />}
          size={pageCtx.buttonSize}
          to={generatePath(routes.handlers.edit, { handlerId })}
        >
          {t('edit')}
        </Control.LinkButton>
      ) : undefined}
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb
            caption={t('breadcrumbs.back_to_handlers')}
            href={routes.handlers.all}
          />
          <Breadcrumb caption={title} />
        </Breadcrumbs>
      )}
      title={title}
    />
  );
}

export { HandlerViewPageHeader };
